import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request/request'

import { handlerServerError } from '@orbit/errors'

export const useDeleteReportFile = (invalidate?: () => Promise<void>, reportQuarterlyId?: number) => {
  const { mutate: deleteReportFile } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.reportFile, opts),
    onSuccess: () => {
      if (reportQuarterlyId && invalidate) invalidate()
    },
    onError: (error) => handlerServerError(error)
  })

  return {
    deleteReportFile
  }
}
